import { Tag } from 'antd';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import React from 'react';

import { getColorByRelativeDate } from './get-color-by-relative-date';

dayjs.extend(relativeTime);

export const getTagByRelativeDate = ({
  date,
}: {
  date: Date;
}): React.ReactElement => {
  const tagColor: string = getColorByRelativeDate({
    date,
  });

  return <Tag color={tagColor}>{dayjs(date).fromNow()}</Tag>;
};
